import React from "react";
import styled from "styled-components";

interface WeeklyTimeBlockProps {
	isAvailable?: boolean;
}

const WeeklyTimeBlock: React.FC<WeeklyTimeBlockProps> = ({ isAvailable }) => {
	return <WeeklyTimeBlockStyles isAvailable={isAvailable} />;
};

export default WeeklyTimeBlock;

const WeeklyTimeBlockStyles = styled.div<WeeklyTimeBlockProps>`
	width: 100%;
	height: 10px;
	background-color: ${(props) => (props.isAvailable ? "hsl(var(--brand))" : "#D4D4D4")};
`;
